import {Component, ElementRef, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {SubFormComponent} from '../../_subform';
import {DateService} from '@services/date.service';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

/**
 * Компонент поверки в форме карточки оборудования
 */

@Component({
    providers: [
    ],
    selector: 'apparatus-card-calibration',
    templateUrl: './apparatus-card-calibration.component.html'
})
export class ApparatusCardCalibrationComponent extends SubFormComponent {

    /*
    * Межповерочный интервал, для автоматического расчета даты окончания
    * поверки
    * */
    @Input() calibrationInterval: any;

    /*
    * Заголовок панели с поверкой
    * */
    @Input() title;

    /**
     * Параметр, является ли форма "Широкой". У широкой и узкой формы по-разному выглядит layout.
     * "Широкая" форма на странице карточки оборудованивая
     * "Узкая" форма в форме в модалке визардка
     *
     * @TODO избавиться от параметра, он больше не нужен
     */
    @Input() wide = true;

    /**
     * Событие, что текущую поверку нужно удалить
     * @type {EventEmitter<any>}
     */
    @Output() remove = new EventEmitter();

    @HostBinding('class') className = 'highlight-container';

    public canRemoveCalibration = false;

    public formGroupTemplate = this._fb.group({
        organization: [''],
        number: [''],
        date_begin: [''],
        date_end: [''],
        files: this._fb.array([])
    });

    constructor(
        public elementRef: ElementRef,
        private dateService: DateService,
        private _fb: FormBuilder,
        private authService: AuthService,
    ) {
        super();
    }

    afterInit() {
        /**
         * При изменении даты начала поверки,
         * если у текущего оборудования указан поверочный интервал и дата окончания поверки еще не заполнена,
         * то автоматически выставляем дату окончания поверки как "Дата начала + длина поверочного интервала минус 1 день"
         */
        const sub = this.form.get('date_begin').valueChanges.subscribe(date => {
            if (this.form.get('date_end').value || !this.calibrationInterval || !this.dateService.for(date).isValid()) {
                return;
            }

            const endDate = this.dateService.for(date).addMonth(this.calibrationInterval).addDay(-1).dateString;
            this.form.get('date_end').patchValue(endDate);
        });
        this.subs.push(sub);

        this.canRemoveCalibration = this.authService.hasPermissions([UserNamespace.Permission.equipmentCardCalibrationRemove]);
    }
}
